module.exports = __webpack_public_path__ + "img/gravier_quartz_blanc.424d09bf.jpg";